export const MODULE_HEADER_EXCEPTIONS = [
  "project-bank",
  "finance",
  "inventory",
  "asset-management",
  "human-resources",
];

export const MODULES_WITH_NATIVE_NASH_HEADER = [
  "student-management",
  "attendee-management",
  "crm",
  "ai-documents",
  "automation-hub",
];

export const UNIVERSAL_MODULE_HEADER_IDS = [
  "mural",
  "company",
  "requests",
  "blocked-ip-addresses",
  "audit",
  "user-manual",
  "profile",
];

const exceptionSet = new Set(MODULE_HEADER_EXCEPTIONS);
const nativeHeaderSet = new Set(MODULES_WITH_NATIVE_NASH_HEADER);
const universalHeaderSet = new Set(UNIVERSAL_MODULE_HEADER_IDS);

export const shouldRenderUniversalModuleHeader = (moduleId) => {
  const id = String(moduleId || "").trim();
  if (!id) return false;
  if (exceptionSet.has(id) || nativeHeaderSet.has(id)) return false;
  return universalHeaderSet.has(id);
};

export default shouldRenderUniversalModuleHeader;
